import React, { useEffect, useRef, useState } from 'react';
import Colors from '../../constants/colors';
import { Icon } from '../general';
// import { } from '../general';
// import Home from '../site/Home';
// import Window from './Window';   


export interface ToolbarProps {
    windows: DesktopWindows;
    toggleMinimize: (key: string) => void;
    shutdown: () => void;
}

const Toolbar: React.FC<ToolbarProps> = ({
    windows,
    toggleMinimize,
    shutdown,
}) => {
    const getTime = () => {
        const date = new Date();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let numberDay = date.getDay();
        let day = date.getDate();
        let amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        let mins = minutes < 10 ? '0' + minutes : minutes;
        const daysOfWeek = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];

        const strTime = daysOfWeek[numberDay] + ' ' + day + ' ' + hours + ':' + mins + ' ' + amPm;
        return strTime;
    };

    const [startWindowOpen, setStartWindowOpen] = useState(false);
    const lastClickInside = useRef(false);

    const [lastActive, setLastActive] = useState('');

    useEffect(() => {
        let max = 0;
        let k = '';
        Object.keys(windows).forEach((key) => {
            if (windows[key].zIndex >= max) {
                max = windows[key].zIndex;
                k = key;
            }
        });
        setLastActive(k);
    }, [windows]);

    const [time, setTime] = useState(getTime());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(getTime());
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const onCheckClick = () => {
        if (lastClickInside.current) {
            setStartWindowOpen(true);
        } else {
            setStartWindowOpen(false);
        }
        lastClickInside.current = false;
    };

    useEffect(() => {
        window.addEventListener('mousedown', onCheckClick, false);
        return () => {
            window.removeEventListener('mousedown', onCheckClick, false);
        };
    }, []);

    const onStartWindowClicked = () => {
        setStartWindowOpen(true);
        lastClickInside.current = true;
    };

    const toggleStartWindow = () => {
        if (!startWindowOpen) {
            lastClickInside.current = true;
        } else {
            lastClickInside.current = false;
        }
    };

    return (
        <div style={styles.toolbarOuter}>
            {startWindowOpen && (
                <div
                    onMouseDown={onStartWindowClicked}
                    style={styles.startWindow}
                >
                    <div style={styles.startWindowInner}>
                        <div style={styles.startWindowContent}>
                            <div
                                className="start-menu-option"
                                style={styles.startMenuOption}

                            >
                                <Icon
                                    style={styles.startMenuIcon}
                                    icon="games"
                                />
                                <p style={styles.startMenuText}>
                                    Juegos
                                </p>
                            </div>
                            
                            <div
                                className="start-menu-option"
                                style={styles.startMenuOption}
                            >
                                <Icon
                                    style={styles.startMenuIcon}
                                    icon="chrome"
                                />
                                <p style={styles.startMenuText}>
                                    Mi portafolio
                                </p>
                            </div>

                            <div
                                className="start-menu-option"
                                style={styles.startMenuOption}
                                // onMouseDown={shutdown}
                            >
                                <Icon
                                    style={styles.startMenuIcon}
                                    icon="term"
                                />
                                <p style={styles.startMenuText}>
                                    Apagar
                                </p>
                            </div>
                            
                        </div>
                    </div>
                    <div
                        style={styles.startWindowRightSection}
                    >
                        <div style={styles.startWindowRightSectionContainerImg}>
                            <img src='/jose.jpeg' alt='Jose Eduardo' style={styles.startWindowRightSectionImg}/>
                        </div>

                        {/* <div
                            style={styles.startWindowRightSectionItems}
                        >
                            <p style={styles.startMenuTextWhite}>
                                My Showcase
                            </p>
                            <p style={styles.startMenuTextWhite}>
                                Doom
                            </p>
                        </div> */}
                    </div>
                </div>
            )}
            <div style={styles.toolbarInner}>
                <div style={styles.toolbar}>
                    <div
                        style={Object.assign(
                            {},
                            styles.startContainerOuter,
                            startWindowOpen && styles.activeTabOuter
                        )}
                        onMouseDown={toggleStartWindow}
                    >
                        <div
                            style={Object.assign(
                                {},
                                styles.startContainer,
                                startWindowOpen && styles.activeTabInner
                            )}
                        >
                            <div
                                style={styles.contentIcon}
                            >
                                <Icon
                                    size={35}
                                    icon="windowsStartIcon"
                                    style={styles.startIcon}
                                />
                                <span
                                    style={styles.lightStartIcon}
                                ></span>
                            </div>
                        </div>
                    </div>
                    <div style={styles.toolbarTabsContainer}>
                        {Object.keys(windows).map((key) => {
                            return (
                                <div
                                    key={key}
                                    style={Object.assign(
                                        {},
                                        styles.tabContainerOuter,
                                        lastActive === key &&
                                        !windows[key].minimized &&
                                        styles.activeTabOuter
                                    )}
                                    onMouseDown={() => toggleMinimize(key)}
                                >
                                    <div
                                        style={Object.assign(
                                            {},
                                            styles.tabContainer,
                                            lastActive === key &&
                                            !windows[key].minimized &&
                                            styles.activeTabInner
                                        )}
                                    >
                                        <Icon
                                            size={30}
                                            icon={windows[key].icon}
                                            style={styles.tabIcon}
                                        />
                                        <p style={styles.tabText}>
                                            {windows[key].name}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div style={styles.time}>
                    <Icon style={styles.volumeIcon} icon="wifi" />
                    <Icon style={styles.volumeIcon} icon="sonido" />
                    <Icon style={styles.volumeIcon} icon="bateria" />
                    <p style={styles.timeText}>{time}</p>
                </div>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    toolbarOuter: {
        boxSizing: 'border-box',
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: 50,
        // background: `rgba(${parseInt(Colors.blue.slice(1, 3), 16)}, ${parseInt(Colors.blue.slice(3, 5), 16)}, ${parseInt(Colors.blue.slice(5, 7), 16)}, 0.2)`,
        background: 'linear-gradient(to left top, rgba(79, 106, 143, 0.7), rgba(111, 141, 179, 0.8), rgba(154, 183, 209, 0.6), rgba(202, 221, 238, 0.4))',
        borderTop: `2px solid ${Colors.darkGray}`,
        zIndex: 100000,
    },
    verticalStartContainer: {
        // width: 30,
        height: '100%',
        background: Colors.darkGray,
    },
    verticalText: {
        fontFamily: 'Terminal',
        textOrientation: 'sideways',
        fontSize: 32,
        padding: 4,
        paddingBottom: 64,
        paddingTop: 8,
        letterSpacing: 1,
        color: Colors.lightGray,
        transform: 'scale(-1)',
        WebkitTransform: 'scale(-1)',
        MozTransform: 'scale(-1)',
        msTransform: 'scale(-1)',
        OTransform: 'scale(-1)',
        // @ts-ignore
        writingMode: 'tb-rl',
    },
    startWindowContent: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-end',
        // alignItems: 'flex-end',
        padding: 5
    },
    startWindow: {
        position: 'absolute',
        bottom: 52,
        display: 'flex',
        flex: 1,
        width: 400,
        height: 400,
        background: 'linear-gradient(to left bottom, rgb(79, 106, 143, 0.9), rgb(111, 141, 179, 0.9), rgba(154, 183, 209, 0.6), rgba(202, 221, 238, 0.4))',
        left: 0,
        boxSizing: 'border-box',
        outline: `2px solid ${Colors.darkGray}`,
        border: `2px solid ${Colors.ligthWhite}`,
        padding: 10,
        borderTopRightRadius: 5,
        borderTopLeftRadius: 5
    },
    activeTabOuter: {
    },
    startWindowInner: {
        border: `2px solid ${Colors.darkGray}`,
        outline: `2px solid ${Colors.ligthWhite}`,
        flex: 1,
        background: 'white',
        borderRadius: 5,
        alignItems: 'start',
        width: 250
    },
    startMenuIcon: {
        width: 32,
        height: 32,
    },
    startMenuText: {
        fontSize: 14,
        fontFamily: 'Segoe , sans-serif',
        marginLeft: 8,
    },
    startMenuTextWhite: {
        fontSize: 14,
        fontFamily: 'Segoe , sans-serif',
        marginLeft: 8,
        color: 'white',
        width: '100%',
        padding: '15px 0'
    },
    startMenuOption: {
        alignItems: 'center',
        // flex: 1,
        height: 24,
        padding: 12,
        width: "85%",
        margin: "3px auto",
        borderRadius: 5,
        // border: "1px solid wheat",
        // outline: "1px solid rgb(111, 141, 179, 0.9)",
    },
    startMenuSpace: {
        flex: 1,
    },
    startMenuLine: {
        height: 1,
        background: Colors.white,
        borderTop: `1px solid ${Colors.darkGray}`,
    },
    startWindowRightSection: {
        width: 150,
        position: "relative"
    },
    startWindowRightSectionContainerImg: {
        position: "absolute",
        width: 90,
        height: 90,
        top: 0,
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "linear-gradient(to right top, rgb(79, 106, 143, 0.9), rgb(111, 141, 179, 0.9), rgba(154, 183, 209, 0.6), rgba(202, 221, 238, 0.4))",
        borderRadius: 10,
        border: `2px solid ${Colors.darkGray}`,
    },
    startWindowRightSectionImg: {
        width: 75,
        height: 75,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        border: `1px solid ${Colors.darkGray}`,
        outline: `1px solid ${Colors.ligthWhite}`,
        borderRadius: 3,
        objectFit: 'cover'
    },
    startWindowRightSectionItems: {
        paddingTop: 100,
        flexDirection: 'column'
    },
    activeTabInner: {
        pointerEvents: 'none',
        background: "#ffffff73",
        borderRadius: 5
    },
    tabContainerOuter: {
        display: 'flex',
        flex: 1,
        maxWidth: 49,
        marginRight: 4,
        boxSizing: 'border-box',
        cursor: 'pointer',
    },
    tabContainer: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        // background: "red",
        justifyContent: "center"
    },
    tabIcon: {
        // marginRight: 6,
    },
    startContainer: {
        alignItems: 'center',
        flexShrink: 1,
        // background: 'red',
        paddingLeft: 15,
        paddingRight: 15,
    },
    startContainerOuter: {
        marginLeft: 3,
        boxSizing: 'border-box',
        cursor: 'pointer',
        border: `none`,
    },
    toolbarTabsContainer: {
        // background: 'blue',
        flex: 1,
        marginLeft: 4,
        marginRight: 4,
        padding: 4
    },
    contentIcon: {
        background: '#023b61',
        borderRadius: 50,
        height: 40,
        width: 40,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
    },
    startIcon: {
        zIndex: 23
    },
    lightStartIcon:{
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'radial-gradient(circle, rgba(3,223,253,1) 0%, rgba(1,74,83,0.06496519721577731) 80%, rgba(0,0,0,0) 100%)',
        transform: 'translateY(50%)',
        zIndex: 1
    },
    toolbarInner: {
        borderTop: `1px solid ${Colors.ligthWhite}`,
        // borderTop: `1px solid red`,
        alignItems: 'center',
        flex: 1,
        height: '100%'
    },
    toolbar: {
        flexGrow: 1,
        width: '100%',
        height: '100%'
    },
    time: {
        flexShrink: 1,
        width: 220,
        height: 24,
        boxSizing: 'border-box',
        marginRight: 4,
        paddingLeft: 4,
        paddingRight: 4,
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    volumeIcon: {
        cursor: 'pointer',
        height: 16,
        margin: "0 5px",
        filter: "invert(1)"
    },
    tabText: {
        fontSize: 0
        
    },
    timeText: {
        fontSize: 13,
        // fontFamily: 'MSSerif',
        color: "#ffffff"
    },
};

export default Toolbar;
